export const getDefault = () => {
  const schema = {
    name: 'SubWebContacts',
    title: 'Contactos do departamento',
    mapUrl: 'https://maps.google.com/maps?output=embed&q=40.629560,-8.656936&z=20',
    main: '**Email:** mail@mail.pt',
    data: '**Telefone**(+351) 234 333 333',
    social: []
  }
  return schema
}
